import GoogleMaps from "./googleMaps.service";

const googleMapsModule = angular
  .module("app.services.googleMaps", [])
  .service("GoogleMaps", GoogleMaps);

export default googleMapsModule;



// WEBPACK FOOTER //
// ./src/services/googleMaps/googleMaps.module.js